import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from "react-router-dom"
import Routing from './routes';
import ComingSoon from './components/ComingSoon/ComingSoon';
import { settingsApi } from './services/api';
import logger from './utils/logger';
import '../src/assets/css/aos.css'
import '../src/assets/css/bootstrap.min.css'
import '../src/assets/css/icofont.min.css'
import '../src/assets/css/magnific-popup.min.css'
import '../src/assets/css/style.css'
import '../src/assets/css/responsive.css'


export default function App() {
  const [isComingSoon, setIsComingSoon] = useState(false);
  const [countdownDate, setCountdownDate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        // Fetch coming soon and countdown settings from API
        const [comingSoon, countdown] = await Promise.all([
          settingsApi.getComingSoonSetting(),
          settingsApi.getCountdownDateSetting(),
        ]);

        setIsComingSoon(comingSoon);
        setCountdownDate(countdown);
      } catch (error) {
        logger.error('Failed to load settings', error);
        // Fallback to environment variables if API fails
        setIsComingSoon(process.env.REACT_APP_COMING_SOON === 'true');
        setCountdownDate(process.env.REACT_APP_COUNTDOWN_DATE || null);
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'LUMO-font, sans-serif'
      }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (isComingSoon) {
    return <ComingSoon countdownDate={countdownDate} />;
  }

  return (
    <>
      <Router >
        <Routing />
      </Router>
    </>
  );
}